(function () {
  'use strict';

  /**
   * @author Ronald Nicholls
   * @class ute-ui.extras
   * @memberOf ute-ui
   */
  angular.module('ute.ui')

  /**
   * @class ute-ui.extras.uteGlobalMessage
   */
    .directive('uteGlobalMessage', function () {

      return {
        restrict: 'E',
        transclude: true,
        scope: {
          globalMessage: '@'
        },
        template: '<div class="alert alert-{{globalMessageObj.type}}"><div><i class="{{iconType}}"></i></div><div><h4><ins translate="{{globalMessageObj.title}}"></ins></h4><ins translate="{{globalMessageObj.code}}"></ins></div></div>',
        controller: ['$scope', function ($scope) {
          if ($scope.globalMessage !== '') {
            $scope.globalMessageObj = JSON.parse($scope.globalMessage);
            switch ($scope.globalMessageObj.type) {
              case 'success':
                $scope.iconType = 'ute-icon-check';
                break;
              case 'error':
              case 'warning':
              case 'danger':
                $scope.iconType = 'ute-icon-error';
                break;
              case 'info':
                $scope.iconType = 'ute-icon-info';
                break;
              default:

            }
          }
        }]
      };

    });


})();
